import React from 'react';
import { useStore } from '@betgames/bg-state-manager';
import { GameDefinition } from 'betgames-contract-js';
import { formatToCurrency } from 'utils/formatToCurrency';
import { webSocketsService } from 'services/WebSockets';
import { auth, authSelectors } from 'store/Auth';
import { sessionStore } from 'store/Session';
import { gameMessage } from 'store/GameMessage';
import { MessageType } from 'store/GameMessage/enums/MessageType';
import { IframeIntegration } from 'integrations';
import { RNG_STREAM_DELAY, WIN_MESSAGE_DURATION } from 'constants/constants';

export const useWinMessage = () => {
    const isAuthenticated = useStore(auth.store, authSelectors.isAuthenticated);

    React.useEffect(() => {
        if (!isAuthenticated) {
            return undefined;
        }

        let timerId: number;
        const unsubscribe = webSocketsService.betWinnings((data) => {
            timerId = window.setTimeout(
                () => {
                    gameMessage.store.add({
                        type: MessageType.WIN,
                        text: 'you_won',
                        duration: WIN_MESSAGE_DURATION,
                        amount: formatToCurrency(
                            data.winning,
                            sessionStore.currencyPrecision,
                            sessionStore.currencyTemplate,
                        ),
                    });

                    IframeIntegration.balanceCheck();
                },
                GameDefinition.isRng(data.gameId) ? RNG_STREAM_DELAY : 0,
            );
        });

        return () => {
            unsubscribe();
            window.clearTimeout(timerId);
        };
    }, [isAuthenticated]);
};
